export const PLAYER_SCHEMA_VERSION = 1;
export const BASE_STATS = { str: 10, agi: 10, vit: 10, int: 10, dex: 10, luk: 10 } as const;
export const BASE_HP = 80;
export const BASE_MP = 30;
export const HP_PER_VIT = 4;
export const MP_PER_INT = 5;
